import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionDataSection,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { TopBuyersSellersDataModel } from './top-buyers-sellers.model';

export class TopBuyersSellersConfiguration extends ReportSectionConfigurationBase {
  typeName = 'TopBuyersSellersConfiguration';
  nodataLocalizationKeyName = 'bnyTopBuyersSellers';
  readonly reportSection = ReportSection.TopBuyersSellers;
  readonly applicableReportTypes = [ReportType.BnyManagementReport];
  readonly reportViewModelSections = [ReportViewModelSection.BnyManagementReport_TopBuyersSellers];
  minSize = 2;
  maxSize = 4;
  defaultSize = 4;
  readonly availableDataSections: ReportSectionDataSection[] = [
    {
      name: 'institutionalBuyers',
      displayName: 'Top-5 Institutional Buyers',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'institutionalSellers',
      displayName: 'Top-5 Institutional Sellers',
      isSelected: true,
      canConfigure: true
    }
  ];

  get name(): string {
    if (this.appliedReportType === ReportType.BnyManagementReport) {
      return 'topBuyersSellers';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.BnyManagementReport) {
      return 'Top Institutional Buyers & Sellers';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface TopBuyersSellersData {
  [ReportViewModelSection.BnyManagementReport_TopBuyersSellers]: {
    topBuyersAndSellers: TopBuyersSellersDataModel;
  };
}
